import { RentalHistory } from '../../models/rentalhistory';
import { RentalHistoryDataService } from '../../../services/rentalhistory.service';
import { ApplicationDataService } from '../../../services/application.service';
import { MoveInReason } from '../../models/moveinreason';
import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Property } from '../../models/property';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service'; 
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { TwoYearsDialogComponent } from './two-years-dialog/two-years-dialog.component';
import { LabelValue } from '../../models/labelvalue';
import { ApplicationInterface } from 'app/interface/application';
import { ErrorService } from 'services/error.service';
import { AnalyticsService } from 'services/analytics.service';

@Component({
  selector: 'app-residency',
  templateUrl: './residency.component.html',
  styleUrls: ['./residency.component.css']
})
export class ResidencyComponent implements OnInit, AfterViewChecked {
  @ViewChild('rentalHistory', { static: true }) private myScrollContainer: ElementRef;
  RentalApplicantKey: number;
  RentalApplicationKey: number;
  history: RentalHistory[];
  states: LabelValue[] = [];
  moveReasons: LabelValue[];
  errorMessage: string;
  displayValidationMsg = false;
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  CompletedByOther: boolean = false;
  modelProperty: Property;
  splashHTML: string;
  minDate = new Date(1910, 0, 1);
  minYear = this.minDate.getFullYear();
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  disableSubmitBtn: Boolean = false;

  @ViewChild('rentalForm', { static: true })
  rentalForm: NgForm;

  constructor(
    private rentalHistoryService: RentalHistoryDataService,
    private applicationService: ApplicationDataService,
    private errorService: ErrorService,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Residency Information',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
    const RentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const RentalApplicantKey = localStorage.getItem('RentalApplicantKey');

    const AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    const AddAdditionalApplicantName = localStorage.getItem('AddAdditionalApplicantName');

    const correctStatus = localStorage.getItem('CorrectStatus');

    if (correctStatus != "true")
    {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Residency Information',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    if(AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined)
    {
      this.AddAdditionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    if(AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) 
    {
      this.AddAdditionalApplicantName = AddAdditionalApplicantName
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");

    if (RentalApplicantKey !== undefined && RentalApplicantKey !== null && RentalApplicationKey !== undefined && RentalApplicationKey !== null) {
      
      this.RentalApplicationKey = Number(RentalApplicationKey);
      
      if(this.AddAdditionalApplicantKey == null)
      {
        this.RentalApplicantKey = Number(RentalApplicantKey);
      }
      else {
        this.RentalApplicantKey = this.AddAdditionalApplicantKey;
      }   

      this.rentalHistoryService.getRentalHistory(RentalApplicantKey, AddAdditionalApplicantKey)
      .subscribe(res => this.onGetRentalHistorySuccess(res), res => this.errorMessage = applicationService.handleError(res));
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Residency Information',
        'Stop',
        'Application or applicant not in the right state',
        '/application/basic',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/basic']);
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'Residencies': this.history?.map(x =>
          {
            return {
              'Rent': x.RentAmount
            };
          }) ?? []
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }

    if (verifastEnabled && verifastEnabled === 'true') {
      this.totalApplicationSteps++;
    }

    this.getStates();
    this.applicationService.getRentalMoveInReasons().subscribe(res => this.getMoveReasons(res),
    res => this.applicationService.handleError(res));
    const property = JSON.parse( localStorage.getItem('SelectedProperty'));
    if (property != null) {
        this.modelProperty = property[0];
        if((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)){
          this.modelProperty.rent = property[0].min_rent.toLocaleString();
        }
        else if (property[0].min_rent != null && property[0].max_rent != null) {
          this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$'+ property[0].max_rent.toLocaleString()
        }
    }
  }
  
  updateSplashHTML(res: string)
  {
    this.splashHTML = res;
  }

  onDateBlur(event) {
    this.rentalForm.controls[event.target.id].updateValueAndValidity({ emitEvent: false });
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  checkRentalHistory() {
    this.disableSubmitBtn = true;
    if (this.history.length > 0) {
      let diffDays = 0;
      if (this.history.length > 0) {
        this.history.sort(function (a, b) {
          return new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime();
        });
        const StartDate = new Date(this.history[0].StartDate);

        let EndDate = this.history[this.history.length - 1].EndDate;
        if (EndDate === null) {
          EndDate = new Date();
        } else {
          EndDate = new Date(EndDate);
        }

        const timeDiff = Math.abs(StartDate.getTime() - EndDate.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      }

      if ((diffDays / 365) < 2) {
        this.twoYears();
      } else {
        this.onSubmit();
      }
    } else {
      this.disableSubmitBtn = false;
      this.onAddHistoryClick();
      this.errorMessage = 'You must enter at least one rental history for your current address';
    }
  }

  twoYears() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";

    let dialogRef = this.dialog.open(TwoYearsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if(result == "yes"){
        this.disableSubmitBtn = false;
        this.onCloseWarning();
      }
      else if(result == "no"){
        this.onSubmit();
      }
    });
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Residency Information',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }

  onSubmit() {
    if (this.history.length > 0) {
      for (const hist of this.history) {
        hist.IsCurrent = false;
        let stringNumber = String(hist.RentAmount);
        stringNumber = stringNumber.replace(/[^\d.]/g, '');
        hist.RentAmount = Number(stringNumber);
      }

      this.history[0].IsCurrent = true;
    }
    this.rentalHistoryService.updateRentalHistory(this.RentalApplicantKey, this.RentalApplicationKey ,this.CompletedByOther, this.history)
    .subscribe(res => this.onUpdateRentalHistorySuccess(res), res => {
      this.disableSubmitBtn = false;
      this.errorMessage = this.applicationService.handleError(res)
    } );
  }

  onCloseWarning() {
    this.disableSubmitBtn = false;
    this.onAddHistoryClick();
  }

  getStates() {
    this.states.push({label: 'AK', value: 'AK'});
    this.states.push({label: 'AL', value: 'AL'});
    this.states.push({label: 'AR', value: 'AR'});
    this.states.push({label: 'AZ', value: 'AZ'});
    this.states.push({label: 'CA', value: 'CA'});
    this.states.push({label: 'CO', value: 'CO'});
    this.states.push({label: 'CT', value: 'CT'});
    this.states.push({label: 'DE', value: 'DE'});
    this.states.push({label: 'FL', value: 'FL'});
    this.states.push({label: 'GA', value: 'GA'});

    this.states.push({label: 'HI', value: 'HI'});
    this.states.push({label: 'IA', value: 'IA'});
    this.states.push({label: 'ID', value: 'ID'});
    this.states.push({label: 'IL', value: 'IL'});
    this.states.push({label: 'IN', value: 'IN'});
    this.states.push({label: 'KS', value: 'KS'});
    this.states.push({label: 'KY', value: 'KY'});
    this.states.push({label: 'LA', value: 'LA'});
    this.states.push({label: 'MA', value: 'MA'});
    this.states.push({label: 'MD', value: 'MD'});

    this.states.push({label: 'ME', value: 'ME'});
    this.states.push({label: 'MI', value: 'MI'});
    this.states.push({label: 'MN', value: 'MN'});
    this.states.push({label: 'MO', value: 'MO'});
    this.states.push({label: 'MS', value: 'MS'});
    this.states.push({label: 'MT', value: 'MT'});
    this.states.push({label: 'NE', value: 'NE'});
    this.states.push({label: 'NH', value: 'NH'});
    this.states.push({label: 'NJ', value: 'NJ'});
    this.states.push({label: 'NM', value: 'NM'});

    this.states.push({label: 'NV', value: 'NV'});
    this.states.push({label: 'NY', value: 'NY'});
    this.states.push({label: 'NC', value: 'NC'});
    this.states.push({label: 'ND', value: 'ND'});
    this.states.push({label: 'OH', value: 'OH'});
    this.states.push({label: 'OK', value: 'OK'});
    this.states.push({label: 'OR', value: 'OR'});
    this.states.push({label: 'PA', value: 'PA'});
    this.states.push({label: 'RI', value: 'RI'});
    this.states.push({label: 'SC', value: 'SC'});

    this.states.push({label: 'SD', value: 'SD'});
    this.states.push({label: 'TN', value: 'TN'});
    this.states.push({label: 'TX', value: 'TX'});
    this.states.push({label: 'UT', value: 'UT'});
    this.states.push({label: 'VT', value: 'VT'});
    this.states.push({label: 'VA', value: 'VA'});
    this.states.push({label: 'WA', value: 'WA'});
    this.states.push({label: 'WI', value: 'WI'});
    this.states.push({label: 'WV', value: 'WV'});
    this.states.push({label: 'WY', value: 'WY'});
  }

  getMoveReasons(reasons: MoveInReason[]) {
    this.moveReasons = [];
    for (const reason of reasons)
    {
      this.moveReasons.push({label: reason.Title, value: reason.RentalMoveInReasonKey});
    }
  }

  onAddHistoryClick() {
    this.disableSubmitBtn = false;
    this.history.push(new RentalHistory());
    this.history[0].IsCurrent = true;
  }

  onRemoveHistoryClick(hist: RentalHistory) {
    const index = this.history.indexOf(hist);
    this.history.splice(index, 1);
    if (this.history.length > 0) {
      this.history[0].IsCurrent = true;
    }

  }

  onGetRentalHistorySuccess(histories: RentalHistory[]) {

    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if(AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined)
    {
        this.CompletedByOther = true;
    }
    else {
      this.CompletedByOther = false;
    }

    for (const hist of histories) {
      hist.StartDate = new Date(hist.StartDate);
      if (hist.EndDate !== null) {
        hist.EndDate = new Date(hist.EndDate);
      }
    }

    this.history = histories;

    if (this.history.length === 0) {
      this.history = [];
      this.history.push(new RentalHistory());
    }
    this.scrollToBottom();
  }

  onUpdateRentalHistorySuccess(histories: RentalHistory[]) {
    this.analyticsService.track(
      'HRA Application',
      'Residency Information',
      'Stop',
      'Sending to employment',
      '/application/employment',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/employment'], {fragment: 'employmentinfo'});
  }

  ListTrack(o) {
    return o;
  }
}
